<template>
  <div class="video component">
    <div class="video__container">
      <div class="video__wrapper" v-if="videoLink">
        <iframe class="video__iframe" :src="videoLink" frameborder="0" allowfullscreen></iframe>
    </div>
      <div class="video__caption" v-if="config.products && config.products.length">
        <p>
          <product-list-component :config="config.products"/>
        </p>
      </div>
      <div class="video__text" v-html="config.label" v-if="config.label"></div>
    </div>
  </div>
</template>

<script>
import ProductListComponent from "./ProductListComponent";

export default {
  name: "EmbedVideo",
  components: { ProductListComponent },
  props: ["config"],
  data() {
    return {
      videoLink: null
    }
  },
  mounted() {
    var result = this.config.url.match(/^https:\/\/v.youku.com\/v_show\/id_(\w+)==.html/);
    if (result && result[1]) {
      this.videoLink = `https://player.youku.com/embed/${result[1]}==`
    } else {
      this.videoLink = this.config.url
    }
  }
};
</script>

<style scoped>
/*copied from publicera*/
.video__container {
  max-width: 768px;
  margin-left: auto;
  margin-right: auto;
  padding: 20px 0;
}

.video__wrapper {
  zoom: 1;
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  width: 100%;
  overflow: hidden;
}

.video__wrapper:after {
  clear: both;
}

.video__wrapper:after,
.video__wrapper:before {
  content: " ";
  display: table;
}

.video__text {
  margin-top: 1rem;
}

.video__text ol,
.video__text ul {
  margin: 1rem 0;
  padding-left: 2.5rem;
}

.video__iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.video__caption {
  font-size: 0.8rem;
  margin-top: 0.3rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/cms/pageComponents/VideoComponent.vue